import React, { Component } from 'react';
import { Container, Button, Form, FormGroup, Label, Input, FormFeedback, Row, Col, CardHeader, Card, ListGroup, ListGroupItem, CardBody, Modal, ModalHeader, ModalBody, CardLink, Media } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify';
import validaciones from '../../Auxiliares/validaciones'
import ReactFileReader from 'react-file-reader'
import SideBar from '../../Img/SideBar.png'
import Return from '../../Img/Regresar.png'

export default class Digitalizar extends Component {
    constructor(state) {
        super(state);
        this.state = {
            lista: "",
        }
    }

    revalidarDocIns() {
        Fetch('/revalidarDocumentoInstitucional', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => {
                toast.success("Revalidación exitosa!")
            })
            .catch(err => {
                toast.error("Error desconocido")
            })
    }

    aspirantesAceptados(){
        const { lista } = this.state
        var array = lista.split(",").map(function(item) {
            return parseInt(item, 10);
        });
        
        // var array = lista.split(",");

        //console.log(array)
        
        Fetch('/aspirantesAceptados', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ lista: array })
        })
            .then(response => {
                toast.success("Aspirantes aceptados!")
            })
            .catch(err => {
                toast.error("Error desconocido")
            })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div class="container-fluid">
                            <h1 class="mt-2 mb-2 text-center">Generador de reportes</h1>
                        </div>
                        <Container>
                            <Card className="p-4">
                                <Row className="mb-2 h-100" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Col xs="12" md="4" className="text-center text-md-right mb-2">
                                        <Button onClick={()=>this.revalidarDocIns()}>Revalidar Documento institucional</Button>
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Input type="textarea" name="descripcion" className="col-12" readonly disabled value="Esta función ejecuta una busqueda en todos los aspirantes analizando el tipo de documento institucional evaluado con el fin de ser cambiado a rechazado en caso de no ser un documento oficial."/>
                                    </Col>
                                </Row>
                                
                                <Row className="mb-2 h-100" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Col xs="12" md="4" className="text-center text-md-right mb-2">
                                        <Button onClick={()=>this.aspirantesAceptados()}>Ejecutar aspirantes aceptados</Button>
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Input type="textarea" name="lista" className="col-12" onChange={this.setValue.bind(this, "lista")}/>
                                    </Col>
                                </Row>
                            </Card>
                        </Container>
                    </Col>
                </Row>
                <Footer />
            </html>
        )
    }
}
